import React, { FC } from 'react';
import BottomSheet from '@/components/BottomSheet';
import Button from '@/components/Button';
import { useRegisterLimitations } from '@/modules/register/hooks/useRegisterLimitations';

interface IPasscodeForgotBottomSheetProps {
  cancelProps?: {
    label: string;
    onClick: () => void;
  };
}

const PasscodeForgotBottomSheet: FC<IPasscodeForgotBottomSheetProps> = ({
  cancelProps = {
    label: 'فعلا نه',
    onClick: () => BottomSheet.close(),
  },
}) => {
  const { logoutLink } = useRegisterLimitations();

  return (
    <div className="flex flex-col gap-y-[32px]">
      <div className="text-sm font-regular text-gray-100">
        کاربر گرامی، درصورتی که کد ورود خود را فراموش کرده‌اید از طریق زیر گزینه
        بازیابی کد ورود را زده و پس از ورود مجدد به برنامه کد ورود جدید خود را
        تعیین کنید.
      </div>
      <div className="flex justify-between gap-x-2">
        <a className="w-[60%]" href={logoutLink('?completely=true')}>
          <Button className="w-full">بازیابی کد ورود</Button>
        </a>
        <Button
          className="m-auto w-[30%]"
          variant="link"
          onClick={cancelProps.onClick}
        >
          {cancelProps.label}
        </Button>
      </div>
    </div>
  );
};

export const openPasscodeForgotBottomSheet = (
  props: IPasscodeForgotBottomSheetProps = {}
) =>
  BottomSheet.open({
    children: <PasscodeForgotBottomSheet {...props} />,
  });

export default PasscodeForgotBottomSheet;
